import { map } from "nanostores";

export const $playlistData = map({});

export function updatePlaylistData(playlistId, data) {
	const previousData = $playlistData.get()[playlistId] || {};
	if (previousData.isEnded) return;
	$playlistData.setKey(playlistId, { ...previousData, ...data });
}

export function getPlaylistData(playlistId) {
	return $playlistData.get()[playlistId];
}
